import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../../assets/images/alphareview_logo.png';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';

const Navbar = () => {
	const [mobileOpen, setMobileOpen] = useState(false);
	const location = useLocation();
	const isHome = location.pathname === '/';

	const scrollToSection = (id) => {
		setMobileOpen(false);
		if (isHome) {
			const el = document.getElementById(id);
			if (el) {
				const offset = 70;
				const bodyRect = document.body.getBoundingClientRect().top;
				const elementRect = el.getBoundingClientRect().top;
				const elementPosition = elementRect - bodyRect;
				const offsetPosition = elementPosition - offset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth',
				});
				return;
			}
		}
		window.location.href = `/#${id}`;
	};

	return (
		<header className='sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200/80 shadow-sm transition-all'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between'>
				{/* 1. Brand Logo */}
				<Link
					to='/'
					onClick={() => setMobileOpen(false)}
					className='flex items-center transition-transform hover:opacity-90'>
					<img
						src={logo}
						alt='AlphaReview Logo'
						style={{ height: '42px', objectFit: 'contain' }}
					/>
				</Link>

				{/* 2. Simple Desktop Navigation (Only 4 core items) */}
				<nav className='hidden md:flex items-center space-x-8'>
					<button
						onClick={() => scrollToSection('features')}
						className='text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors'>
						Features
					</button>
					<button
						onClick={() => scrollToSection('how-it-works')}
						className='text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors'>
						How It Works
					</button>
					<Link
						to='/pricing'
						className='text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors'>
						Pricing
					</Link>
					<button
						onClick={() => scrollToSection('faq')}
						className='text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors'>
						FAQ
					</button>
				</nav>

				{/* 3. Simple Desktop Actions */}
				<div className='hidden md:flex items-center space-x-5'>
					<a
						href='/user'
						className='text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors'>
						Business Login
					</a>

					<Link
						to='/pricing'
						className='px-5 py-2.5 rounded-xl text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 transition-all shadow-sm'>
						Order Cards
					</Link>
				</div>

				{/* 4. Simple Mobile Controls (Just hamburger) */}
				<div className='flex md:hidden items-center gap-3'>
					<Link
						to='/pricing'
						className='px-3.5 py-1.5 rounded-lg text-xs font-bold text-white bg-blue-600 shadow-sm'>
						Order
					</Link>
					<button
						onClick={() => setMobileOpen(!mobileOpen)}
						className='p-2 text-slate-700 hover:text-blue-600 focus:outline-none'
						aria-label='Toggle menu'>
						{mobileOpen ? (
							<AiOutlineClose className='text-2xl text-slate-800' />
						) : (
							<AiOutlineMenu className='text-2xl text-slate-800' />
						)}
					</button>
				</div>
			</div>

			{/* 5. Simple Mobile Drawer */}
			{mobileOpen && (
				<div className='md:hidden bg-white border-t border-slate-100 px-6 py-5 shadow-lg space-y-4 animate-fadeIn'>
					<div className='space-y-3 font-semibold text-base text-slate-700'>
						<button
							onClick={() => scrollToSection('features')}
							className='w-full text-left py-1 hover:text-blue-600'>
							Features
						</button>
						<button
							onClick={() => scrollToSection('how-it-works')}
							className='w-full text-left py-1 hover:text-blue-600'>
							How It Works
						</button>
						<Link
							to='/pricing'
							onClick={() => setMobileOpen(false)}
							className='block py-1 hover:text-blue-600'>
							Pricing
						</Link>
						<button
							onClick={() => scrollToSection('faq')}
							className='w-full text-left py-1 hover:text-blue-600'>
							FAQ
						</button>
					</div>

					<div className='pt-4 border-t border-slate-100 space-y-2.5'>
						<a
							href='/user'
							className='block w-full text-center py-2.5 rounded-xl text-sm font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200'>
							Business Login
						</a>
						<Link
							to='/pricing'
							onClick={() => setMobileOpen(false)}
							className='block w-full text-center py-3 rounded-xl text-sm font-bold text-white bg-blue-600 shadow'>
							Order Smart Cards (From ₹999)
						</Link>
					</div>
				</div>
			)}
		</header>
	);
};

export default Navbar;
